var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scheduler-container scheduler-container--pricing" },
    [
      _vm.loading ? _c("spinner-loader") : _vm._e(),
      _vm._v(" "),
      _c("DayPilotScheduler", {
        ref: "scheduler",
        attrs: {
          id: "pricing-scheduler",
          config: _vm.config,
          resources: _vm.resources,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scheduler-date-tools" },
        [
          _c(
            "b-button",
            {
              staticClass: "scheduler-today-button",
              on: { click: _vm.scrollToToday },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("scheduler.today_button").toUpperCase()) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "scheduler-cal-icon fi-calendar" }),
          _vm._v(" "),
          _c("v-date-picker", {
            staticClass: "scheduler-date-picker",
            attrs: { mode: "single", "show-caps": "" },
            model: {
              value: _vm.selectedDate,
              callback: function ($$v) {
                _vm.selectedDate = $$v
              },
              expression: "selectedDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pricing-rules-modal", {
        ref: "pricing-rules-modal",
        on: { updated: _vm.update },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }